import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42873582"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "manageQuestionView" }
const _hoisted_2 = { class: "stat-cell" }
const _hoisted_3 = { class: "stat-text" }
const _hoisted_4 = {
  key: 0,
  class: "config-cell"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "detail-answer" }
const _hoisted_10 = {
  key: 0,
  class: "detail-cases"
}
const _hoisted_11 = { key: 1 }

import { computed, onMounted, ref } from "vue";
import { Question, QuestionControllerService } from "../../../generated";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageQuestionView',
  setup(__props) {

const router = useRouter();

const dataList = ref<Question[]>([]);
const total = ref(0);
const searchParams = ref<any>({
  title: "",
  tags: [],
  current: 1,
  pageSize: 15,
});

const loadData = async () => {
  const params: any = {
    current: searchParams.value.current,
    pageSize: searchParams.value.pageSize,
  };
  if (searchParams.value.title) {
    params.title = searchParams.value.title;
  }
  if (searchParams.value.tags?.length) {
    params.tags = searchParams.value.tags;
  }
  const res = await QuestionControllerService.listQuestionByPageUsingPost(
    params
  );
  if (res.code === 0) {
    dataList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error("加载失败，" + res.message);
  }
};

onMounted(() => {
  loadData();
});

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    width: 65,
    sortable: { sortDirections: ["ascend", "descend"] },
  },
  { title: "标题", slotName: "title", ellipsis: true },
  { title: "标签", slotName: "tags", width: 200 },
  { title: "通过率", slotName: "statistics", width: 160 },
  { title: "判题配置", slotName: "judgeConfig", width: 140 },
  { title: "创建时间", slotName: "createTime", width: 120 },
  { title: "操作", slotName: "optional", width: 160 },
];

const onPageChange = (page: number) => {
  searchParams.value.current = page;
  loadData();
};

const doSearch = () => {
  searchParams.value.current = 1;
  loadData();
};

const parseJson = (str: any) => {
  if (!str) return null;
  try {
    if (typeof str === "string") return JSON.parse(str);
    return str;
  } catch {
    return null;
  }
};

const formatMemory = (val: any) => {
  if (!val) return "-";
  return val + "KB";
};

const getRateColor = (record: Question) => {
  if (!record.submitNum) return "#86909c";
  const rate = record.acceptedNum / record.submitNum;
  if (rate >= 0.6) return "#00b42a";
  if (rate >= 0.3) return "#ff7d00";
  return "#f53f3f";
};

// 详情弹窗
const detailVisible = ref(false);
const detailRecord = ref<Question | null>(null);
const testCases = computed(() => {
  if (!detailRecord.value) return [];
  return parseJson(detailRecord.value.judgeCase) || [];
});

const doView = (record: Question) => {
  detailRecord.value = record;
  detailVisible.value = true;
};

const doUpdate = (record: Question) => {
  router.push({ path: "/update/question", query: { id: record.id } });
};

const doDelete = async (record: Question) => {
  const res = await QuestionControllerService.deleteQuestionUsingPost({
    id: record.id,
  });
  if (res.code === 0) {
    message.success("删除成功");
    loadData();
  } else {
    message.error("删除失败");
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_tag = _resolveComponent("a-input-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_progress = _resolveComponent("a-progress")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, {
      title: "题目管理",
      bordered: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: searchParams.value,
          layout: "inline",
          style: {"margin-bottom":"16px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              field: "title",
              label: "标题"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: searchParams.value.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.title) = $event)),
                  placeholder: "搜索题目",
                  "allow-clear": "",
                  onPressEnter: doSearch
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "tags",
              label: "标签"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_tag, {
                  modelValue: searchParams.value.tags,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.tags) = $event)),
                  placeholder: "输入标签",
                  style: {"width":"200px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: doSearch
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("搜索")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_a_table, {
          columns: columns,
          data: dataList.value,
          pagination: {
          showTotal: true,
          pageSize: searchParams.value.pageSize,
          current: searchParams.value.current,
          total: total.value,
        },
          onPageChange: onPageChange,
          "row-key": "id"
        }, {
          title: _withCtx(({ record }) => [
            _createVNode(_component_a_link, {
              onClick: ($event: any) => (_unref(router).push(`/view/question/${record.id}`))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(record.title), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          tags: _withCtx(({ record }) => [
            _createVNode(_component_a_space, { wrap: "" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseJson(record.tags), (tag, index) => {
                  return (_openBlock(), _createBlock(_component_a_tag, {
                    key: index,
                    color: "cyan",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tag), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 2
            }, 1024)
          ]),
          statistics: _withCtx(({ record }) => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_progress, {
                percent: 
                record.submitNum ? record.acceptedNum / record.submitNum : 0
              ,
                "show-text": false,
                size: "small",
                color: getRateColor(record),
                style: {"width":"80px","display":"inline-block","vertical-align":"middle"}
              }, null, 8, ["percent", "color"]),
              _createElementVNode("span", _hoisted_3, _toDisplayString(record.acceptedNum || 0) + "/" + _toDisplayString(record.submitNum || 0), 1)
            ])
          ]),
          judgeConfig: _withCtx(({ record }) => [
            (parseJson(record.judgeConfig))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("span", null, _toDisplayString(parseJson(record.judgeConfig)?.timeLimit || "-") + "ms", 1),
                  _hoisted_5,
                  _createElementVNode("span", null, _toDisplayString(formatMemory(parseJson(record.judgeConfig)?.memoryLimit)), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, "-"))
          ]),
          createTime: _withCtx(({ record }) => [
            _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD")), 1)
          ]),
          optional: _withCtx(({ record }) => [
            _createVNode(_component_a_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  size: "small",
                  type: "text",
                  onClick: ($event: any) => (doView(record))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 查看 ")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_a_button, {
                  size: "small",
                  type: "text",
                  onClick: ($event: any) => (doUpdate(record))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 编辑 ")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_a_popconfirm, {
                  content: "确定删除该题目吗？",
                  onOk: ($event: any) => (doDelete(record))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      size: "small",
                      type: "text",
                      status: "danger"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 删除 ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onOk"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["data", "pagination"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: detailVisible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((detailVisible).value = $event)),
      title: "题目详情",
      footer: false,
      width: "700px"
    }, {
      default: _withCtx(() => [
        (detailRecord.value)
          ? (_openBlock(), _createBlock(_component_a_descriptions, {
              key: 0,
              column: 1,
              bordered: "",
              size: "small"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions_item, { label: "ID" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(detailRecord.value.id), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "标题" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(detailRecord.value.title), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "标签" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseJson(detailRecord.value.tags), (tag, i) => {
                      return (_openBlock(), _createBlock(_component_a_tag, {
                        key: i,
                        color: "cyan",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tag), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "判题配置" }, {
                  default: _withCtx(() => [
                    (parseJson(detailRecord.value.judgeConfig))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, " 时间: " + _toDisplayString(parseJson(detailRecord.value.judgeConfig)?.timeLimit) + "ms, 内存: " + _toDisplayString(formatMemory(parseJson(detailRecord.value.judgeConfig)?.memoryLimit)) + ", 栈: " + _toDisplayString(formatMemory(parseJson(detailRecord.value.judgeConfig)?.stackLimit)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8, "-"))
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "统计" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 提交: " + _toDisplayString(detailRecord.value.submitNum || 0) + ", 通过: " + _toDisplayString(detailRecord.value.acceptedNum || 0), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "创建时间" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(moment)(detailRecord.value.createTime).format("YYYY-MM-DD HH:mm")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "答案",
                  span: 1
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("pre", _hoisted_9, _toDisplayString(detailRecord.value.answer), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "测试用例" }, {
                  default: _withCtx(() => [
                    (testCases.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(testCases.value, (tc, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: i,
                              class: "case-item"
                            }, [
                              _createElementVNode("span", null, "用例" + _toDisplayString(i + 1) + ": " + _toDisplayString(tc.input?.substring(0, 50)) + "...", 1)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11, "-"))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})